<!--  -->
<template>
  <div>
    <div class="sizew_text">
      <div
        class="sadrw"
        style="width: 120px;"
      >监测链接组名称：</div>
      <el-input
        v-model="feedback_name"
        placeholder="请输入标题"
        class="text_serw"
      />
    </div>
    <div class="sizew_text">
      <div
        class="sadrw"
        style="width: 120px;"
      >营销载体类型：</div>
      <el-select v-model="second_category_type" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>
    <div class="sizew_text">
      <div
        class="sadrw"
        style="width: 120px;"
      >监测链接：</div>
      <el-checkbox-group v-model="category_type" @change="handleSelectionChange">
        <el-checkbox-button v-for="item in options2" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox-button>
      </el-checkbox-group>
    </div>
    <div v-for="item in feedbackList" :key="item.feedback_type">
      <div class="sizew_text">
        <div class="sadrw" style="width: 120px;">{{ item.label }}：</div>
        <el-input v-model="item.feedback_url" :disabled="item.label === '点击'" placeholder="请输入监测链接" />
      </div>
    </div>
    <el-button
      type="primary"
      @click="qundwrok"
    >确定</el-button>
  </div>
</template>

<script>
import { updAdFeedback } from '@/api/report/accountManagement'

export default {
  components: {},
  data() {
    return {
      feedback_name: null,
      checkboxGroup1: [],
      options: [{ value: 'ANDROID', label: '安卓' },
        { value: 'IOS', label: 'iOS' },
        { value: 'QUICK_APP', label: '快应用' },
        { value: 'WEB', label: 'Web' },
        { value: 'WECHAT_OFFICIAL_ACCOUNT', label: '微信公众号' },
        { value: 'WECHAT_CHANNELS', label: '微信视频号' },
        { value: 'WECHAT_MINI_PROGRAM', label: '微信小程序' },
        { value: 'WECOM', label: '企业微信' }],
      options2: [
        { value: 'click', label: '点击' },
        { value: 'official', label: '公众号' },
        { value: 'wecom', label: '企业微信' }
      ],
      second_category_type: 'WECOM',
      category_type: ['click'],
      selectedValues: [],
      feedbackList: [{ feedback_type: 'click', label: '点击', feedback_url: 'https://api.jingxuanhz.com/adq/direct_link/notify?click_id=__CLICK_ID__&click_time=__CLICK_TIME__&account_id=__ACCOUNT_ID__&callback=__CALLBACK__&request_id=__REQUEST_ID__&impression_id=__IMPRESSION_ID__&adgroup_id=__ADGROUP_ID__' }]
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(account_ids) {
      this.account_ids = []
      this.account_ids = account_ids
    },
    qundwrok() {
      if (!this.feedback_name || this.feedbackList.find(item => item.feedback_url === '')) {
        return this.$message.error('请填入完整值')
      }
      updAdFeedback({
        account_ids: this.account_ids,
        feedback_name: this.feedback_name,
        second_category_type: this.second_category_type,
        url_info_list: this.feedbackList
      }).then(res => {
        if (res.code === 0) {
          this.$message.success(res.message)
        }
      })
      this.$emit('updAdFeedback')
    },
    handleSelectionChange(selected) {
      this.feedbackList = selected.map(value => {
        // 查找选项的 label
        const option = this.options2.find(opt => opt.value === value)
        // 查找是否已存在
        const existingItem = this.feedbackList.find(item => item.feedback_type === value)
        return existingItem || {
          feedback_type: value,
          feedback_url: option.label === '点击' ? 'https://api.jingxuanhz.com/adq/direct_link/notify?click_id=__CLICK_ID__&click_time=__CLICK_TIME__&account_id=__ACCOUNT_ID__&callback=__CALLBACK__&request_id=__REQUEST_ID__&impression_id=__IMPRESSION_ID__' : '',
          label: option ? option.label : ''
        }
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sizew_text {
  color: rgb(169, 162, 151);
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.sadrw {
  width: 70px;
  text-align: right;
}
.text_serw{
  width: 200px;
}
</style>
